module.exports = __webpack_public_path__ + "static/media/COM_ERROR_OFF.67ac800a.png";